import { render, staticRenderFns } from "./TheNavbarHorizontal.vue?vue&type=template&id=28b2f707"
import script from "./TheNavbarHorizontal.vue?vue&type=script&lang=js"
export * from "./TheNavbarHorizontal.vue?vue&type=script&lang=js"
import style0 from "./TheNavbarHorizontal.vue?vue&type=style&index=0&id=28b2f707&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports